import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './Profile.css';

const Profile: React.FC = () => {
  const navigate = useNavigate();

  const userInfo = {
    name: 'أحمد محمد',
    phone: '+961 70 123 456',
    email: 'ahmed@example.com',
    avatar: '👤'
  };

  const menuSections = [
    {
      title: 'Account',
      items: [
        { icon: '👤', label: 'Profile', path: '/profile/edit' },
        { icon: '📚', label: 'My Courses', path: '/profile/courses' },
        { icon: '📝', label: 'Quizzes', path: '/profile/quizzes' },
        { icon: '📖', label: 'Books', path: '/profile/books' },
        { icon: '📋', label: 'Orders', path: '/orders' },
        { icon: '❓', label: 'Support', path: '/support' }
      ]
    },
    {
      title: 'Settings',
      items: [
        { icon: 'ℹ️', label: 'About', path: '/profile/about' },
        { icon: '🔒', label: 'Privacy Policy', path: '/profile/privacy' },
        { icon: '⚙️', label: 'Settings', path: '/settings' },
        { icon: '🗑️', label: 'Delete Account', path: '/delete-account' }
      ]
    }
  ];

  return (
    <div className="profile-page">
      <header className="profile-header">
        <button className="profile-back-button" onClick={() => navigate('/')}>
          ←
        </button>
        <h1>Profile</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="profile-content">
        {/* User Info Section */}
        <div className="user-info-card">
          <div className="user-avatar-large">{userInfo.avatar}</div>
          <h2 className="user-name">{userInfo.name}</h2>
          <p className="user-phone">{userInfo.phone}</p>
          {userInfo.email && (
            <p className="user-email">{userInfo.email}</p>
          )}
        </div>

        {/* Menu Sections */}
        {menuSections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="profile-section">
            <h3 className="section-title">{section.title}</h3>
            <div className="profile-menu-list">
              {section.items.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className="profile-menu-item"
                  onClick={() => navigate(item.path)}
                >
                  <div className="menu-item-left">
                    <span className="menu-item-icon">{item.icon}</span>
                    <span className="menu-item-label">{item.label}</span>
                  </div>
                  <span className="menu-item-arrow">›</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default Profile;

